import styled from "styled-components";

import {
  FONTS,
  FONT_SIZE,
  HIDDEN_SCROLLBAR_STYLES,
  SIDEBAR_WIDTH,
} from "../../../constants/Styles";
import { MAX_BODY_SIZE } from "../ReviewBoardFlowStyles";

const Container = styled.div`
  display: flex;
  gap: 1rem;
  flex-grow: 1;
  max-width: ${MAX_BODY_SIZE};
`;

const Sidebar = styled.div`
  min-width: ${SIDEBAR_WIDTH};
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Body = styled.div`
  flex: 1;
  padding: 0 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 3rem;

  ${HIDDEN_SCROLLBAR_STYLES};
`;

const SidebarRow = styled.div<{ isSelected: boolean }>`
  cursor: pointer;
  align-items: center;
  font-size: ${FONT_SIZE.size14};
  display: flex;
  gap: 0.5rem;

  ${({ isSelected }) => !isSelected && `filter: brightness(50%);`}
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
`;

const SubTitle = styled.div<{ isSecondElement?: boolean }>`
  font-family: ${FONTS.spaceGrotesk};
  font-size: ${FONT_SIZE.size24};
`;

const Section = styled.div<{ isSecondElement?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-start;
`;

export {
  Container,
  Sidebar,
  Body,
  SidebarRow,
  IconContainer,
  SubTitle,
  Section,
};
